<template>
  <div>
    <el-col
      :span='24'
      class="title"
    >
      <p class="name">{{content.customerName}}</p>
      <p class="webUrl">{{content.domain}}</p>
    </el-col>
    <el-col
      :span="24"
      class="industry"
    >
      <span>{{content.primaryIndustryName}}</span>
      <span>{{content.secondIndustryName }}</span>
    </el-col>
    <el-col class="kernel">
      <div class="product">
        <p class="title">核心产品：</p>
        <div class="items">
          <el-tag
            v-for="tag in content.coreProducts"
            :key="tag"
            closable
            disable-transitions
            @close="handleClose(tag, 'product')"
          >
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="PinputVisible"
            v-model="inputValue"
            v-focus
            ref="saveTagInput"
            size="small"
            @blur="handleInputConfirm('product')"
            @keyup.enter.native="handleInputConfirm('product')"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput('product')"
          >+ 产品</el-button>
        </div>
      </div>
      <div class="keyword">
        <p class="title">{{divisive === '1' ? '核心关键词：' : '关键词保护：'}}</p>
        <div class="items">
          <el-tag
            v-for="tag in keywordList"
            :key="tag"
            closable
            disable-transitions
            @close="handleClose(tag, 'keyword')"
          >
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="KinputVisible"
            v-model="inputValue"
            v-focus
            ref="saveTagInput"
            size="small"
            @blur="handleInputConfirm('keyword')"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput('keyword')"
          >+ 关键词</el-button>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
import seo from "@/backend/services/seo/seoBoard.js";
export default {
  data() {
    return {
      inputValue: "",
      PinputVisible: false,
      KinputVisible: false
    };
  },
  props: ["content", "divisive"],
  computed: {
    keywordList() {
      return this.divisive === "1"
        ? this.content.coreKeywords
        : this.content.keywordToProtects;
    }
  },
  methods: {
    // 显示
    showInput(event) {
      if (event === "product") {
        this.PinputVisible = true;
      } else {
        this.KinputVisible = true;
      }
    },
    // 删除
    async handleClose(tag, type) {
      let { coreProducts, coreKeywords, keywordToProtects } = this.content;
      let { divisive } = this;

      if (type === "product") {
        coreProducts.splice(coreProducts.indexOf(tag), 1);
      }
      if (type === "keyword") {
        if (divisive === "1") {
          coreKeywords.splice(coreKeywords.indexOf(tag), 1);
        }
        if (divisive === "2") {
          keywordToProtects.splice(keywordToProtects.indexOf(tag), 1);
        }
      }

      this.setwebsiteup();
    },
    // 添加
    async handleInputConfirm(type) {
      let { inputValue, divisive } = this;

      let { coreProducts, coreKeywords, keywordToProtects } = this.content;
      if (inputValue) {
        if (type === "product") {
          coreProducts.push(inputValue);
        }
        if (type === "keyword") {
          if (divisive === "1") {
            coreKeywords.push(inputValue);
          }
          if (divisive === "2") {
            keywordToProtects.push(inputValue);
          }
        }
      } else {
        this.$message({
          message: "请输入内容",
          type: "warning",
          duration: 1500
        });
        this.PinputVisible = false;
        this.KinputVisible = false;
        return false;
      }

      this.PinputVisible = false;
      this.KinputVisible = false;
      this.setwebsiteup();
      this.inputValue = "";
    },

    async setwebsiteup() {
      let { coreProducts, coreKeywords, keywordToProtects, id } = this.content;

      let res = await seo.setwebsiteup(id, {
        coreProduct: coreProducts.join(","),
        coreKeyword: coreKeywords.join(","),
        keywordToProtect: keywordToProtects.join(",")
      });
      if (res.status === 204) {
        this.$message({
          message: "设置成功",
          type: "success",
          duration: 1500
        });
      }
    }
  },
  components: {},
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function(el) {
        // 聚焦元素
        el.querySelector("input").focus();
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .name {
    font-weight: 700;
  }
  .webUrl {
    color: #54a8fe;
    margin-left: 20px;
  }
}
.industry {
  font-size: 14px;
  padding: 20px 0 18px;
  span {
    padding-right: 30px;
  }
}
.kernel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .product,
  .keyword {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2px 0;
    .title {
      font-size: 14px;
      font-weight: 700;
    }
    .items {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;
      font-size: 14px;
      // margin: 0 30px 0 20px;
      .el-tag {
        margin: 5px;
      }
      .input-new-tag {
        width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px;
      }
      .button-new-tag {
        margin: 5px;
      }
    }
  }
  .product {
    padding-right: 15px;
  }
  .keyword {
    padding-left: 15px;
  }
}
.kernel:after {
  content: "";
  display: block;
  width: 1px;
  height: 100px;
  background-color: #f1f4f9;
  position: absolute;
  top: -58px;
  left: 50%;
  margin-right: 1px;
}
</style>
